import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { PassRedeemFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkPassRedeemPOSTErrorResponse, ParkPassRedeemPOSTRequest, ParkPassRedeemPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchPassRedeem = async (data: ParkPassRedeemPOSTRequest): Promise<ParkPassRedeemPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPassRedeemPOSTSuccessResponse>("/pass-redeem", data);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkPassRedeemPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PassRedeemFailReason.SystemError };
  }
};
